// Swiper.js Reviews Carousel - Fixed Version
(function() {
 'use strict';
 
 function initSwiperCarousels() {
   console.log('Initializing Swiper reviews carousels...');
   
   const carousels = document.querySelectorAll('.reviews-carousel-section [data-carousel]');
   console.log(`Found ${carousels.length} reviews carousels`);
   
   carousels.forEach((carousel, index) => {
     const track = carousel.querySelector('[data-track]');
     const dotsContainer = carousel.querySelector('[data-dots]');
     
     if (!track) {
       console.error('Track not found for carousel', index);
       return;
     }
     
     // Add Swiper classes
     carousel.classList.add('swiper');
     track.classList.add('swiper-wrapper');
     
     // Convert slides to swiper-slide
     const slides = track.querySelectorAll('[data-slide]');
     slides.forEach(slide => {
       slide.classList.add('swiper-slide');
     });
     
     // Create dots container if missing
     if (!dotsContainer) {
       const newDotsContainer = document.createElement('div');
       newDotsContainer.className = 'carousel-dots swiper-pagination';
       newDotsContainer.setAttribute('data-dots', '');
       carousel.appendChild(newDotsContainer);
     } else {
       dotsContainer.classList.add('swiper-pagination');
     }
     
     // Destroy existing swiper if it exists
     if (carousel.swiperInstance) {
       carousel.swiperInstance.destroy(true, true);
     }
     
     // Initialize Swiper with mobile-first approach
     const swiper = new Swiper(carousel, {
       // Basic settings - Mobile first
       slidesPerView: 1,
       spaceBetween: 20,
       loop: slides.length > 1, // Only loop if we have more than 1 slide
       centeredSlides: false,
       
       // Autoplay
       autoplay: slides.length > 1 ? {
         delay: 4000,
         disableOnInteraction: false,
         pauseOnMouseEnter: true,
       } : false,
       
       // Mobile-first responsive breakpoints
       breakpoints: {
         // Mobile: 1 slide (default above)
         320: {
           slidesPerView: 1,
           spaceBetween: 16,
         },
         // Large mobile: still 1 slide
         480: {
           slidesPerView: 1,
           spaceBetween: 20,
         },
         // Tablet: 2 slides
         768: {
           slidesPerView: 2,
           spaceBetween: 24,
         },
         // Desktop: 3 slides
         1024: {
           slidesPerView: 3,
           spaceBetween: 30,
         },
         // Large desktop: 4 slides
         1200: {
           slidesPerView: 4,
           spaceBetween: 30,
         },
         // Extra Large: 5 slides
         1420: {
           slidesPerView: 5,
           spaceBetween: 30,
         }
       },
       
       // Navigation
       pagination: {
         el: carousel.querySelector('[data-dots]'),
         clickable: true,
         bulletClass: 'carousel-dot',
         bulletActiveClass: 'active',
         dynamicBullets: false,
         renderBullet: function (index, className) {
           return '<span class="' + className + '"></span>';
         },
       },
       
       // Effects
       speed: 300,
       effect: 'slide',
       
       // Touch/Mouse - More permissive for mobile
       grabCursor: true,
       touchRatio: 1,
       touchAngle: 90, // More permissive angle
       touchStartPreventDefault: false,
       touchMoveStopPropagation: false,
       
       // Resistance
       resistance: true,
       resistanceRatio: 0.85,
       
       // Prevent clicks during transition
       preventClicks: true,
       preventClicksPropagation: true,
       
       // Observer for dynamic content
       observer: true,
       observeParents: true,
       observeSlideChildren: true,
       
       // Events for debugging
       on: {
         init: function() {
           console.log('Swiper initialized for carousel', index);
           console.log('Slides count:', this.slides.length);
           console.log('Current slidesPerView:', this.params.slidesPerView);
         },
         slideChange: function() {
           console.log('Slide changed to:', this.activeIndex);
         },
         touchStart: function() {
           console.log('Touch start detected');
         },
         touchMove: function() {
           console.log('Touch move detected');
         }
       }
     });
     
     // Store swiper instance
     carousel.swiperInstance = swiper;
     
     // Force update after initialization
     setTimeout(() => {
       if (swiper && !swiper.destroyed) {
         swiper.update();
         swiper.updateSlides();
         swiper.updateProgress();
         swiper.updateSlidesClasses();
       }
     }, 100);
   });
 }
 
 // Initialize when DOM is ready and Swiper is loaded
 function initWhenReady() {
   if (typeof Swiper !== 'undefined') {
     // Wait a bit more to ensure all styles are loaded
     setTimeout(initSwiperCarousels, 200);
   } else {
     console.log('Swiper not loaded yet, waiting...');
     setTimeout(initWhenReady, 100);
   }
 }
 
 // Handle both initial load and dynamic content
 if (document.readyState === 'loading') {
   document.addEventListener('DOMContentLoaded', initWhenReady);
 } else {
   initWhenReady();
 }
 
 // Re-initialize on window resize (debounced)
 let resizeTimeout;
 window.addEventListener('resize', function() {
   clearTimeout(resizeTimeout);
   resizeTimeout = setTimeout(function() {
     const carousels = document.querySelectorAll('.reviews-carousel-section [data-carousel]');
     carousels.forEach(carousel => {
       if (carousel.swiperInstance && !carousel.swiperInstance.destroyed) {
         carousel.swiperInstance.update();
       }
     });
   }, 250);
 });
 
})();